import React from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App.js";
import "./styles.css";

// Auth flow uses FULL-PAGE REDIRECT (see admin/auth.ts comment). After
// Microsoft redirects back to mktgassets.moldex.com/#code=…, this boot
// detects the hash, renders a placeholder, lets MSAL consume the code
// (cached into sessionStorage), strips the hash, and reloads the picker
// at a clean URL. After reload the user is signed in.
const url = new URL(window.location.href);
const isAuthCallback =
  url.hash.includes("code=") ||
  url.hash.includes("error=") ||
  url.searchParams.has("code") ||
  url.searchParams.has("error");
const adminFlagged =
  url.searchParams.get("admin") === "1" ||
  url.searchParams.get("admin") === "true" ||
  (typeof sessionStorage !== "undefined" &&
    sessionStorage.getItem("moldex-admin-mode") === "1");

 
console.log("[main] boot", { href: url.href, isAuthCallback, adminFlagged });

const rootEl = document.getElementById("root");
if (!rootEl) throw new Error("no #root element");

if (isAuthCallback) {
  createRoot(rootEl).render(<AuthCallbackScreen />);
  void (async () => {
    try {
      const { getMsal } = await import("./admin/auth.js");
      await getMsal();
       
      console.log("[main] auth callback processed; reloading clean");
    } catch (e) {
       
      console.error("[main] getMsal during callback failed", e);
    }
    const clean = window.location.pathname + window.location.search;
    window.history.replaceState(null, "", clean);
    window.location.reload();
  })();
} else {
  if (adminFlagged) {
    void import("./admin/auth.js").then((m) => m.getMsal());
  }
  createRoot(rootEl).render(<App />);
}

function AuthCallbackScreen() {
  return (
    <div
      style={{
        height: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexDirection: "column",
        gap: "1rem",
        background: "#20368c",
        color: "white",
        fontFamily: "Segoe UI, system-ui, sans-serif",
        padding: "2rem",
        textAlign: "center",
      }}
    >
      <div style={{ fontSize: "1.4rem", fontWeight: 700 }}>Completing sign-in…</div>
      <div style={{ fontSize: "0.85rem", opacity: 0.8 }}>One moment.</div>
    </div>
  );
}
